module.exports = __webpack_public_path__ + "static/media/1795601_716067768414648_1931851520_n.b1061a4b.jpg";